module.exports = __webpack_public_path__ + "static/img/teacher6.5d81d525.png";